__turbopack_context__.v({
  "createAccountButton": "ReturnsForm-module-scss-module__-dWz2W__createAccountButton",
  "formContainer": "ReturnsForm-module-scss-module__-dWz2W__formContainer",
  "isDisabled": "ReturnsForm-module-scss-module__-dWz2W__isDisabled",
  "loginButton": "ReturnsForm-module-scss-module__-dWz2W__loginButton",
  "loginErrorMessage": "ReturnsForm-module-scss-module__-dWz2W__loginErrorMessage",
});
